import KFAnalyticsScreen from './KFAnalyticsScreen';

export default KFAnalyticsScreen;
